module.exports = __webpack_public_path__ + "img/icon-check-active.f44d6048.svg";